import AbstractSystem from "../all/AbstractSystem";

class ArrisSystem extends AbstractSystem {
    
    exit() {
        window.open('/node/homeuser', '_self', '');
        window.close();
    }
}

export default ArrisSystem;



// WEBPACK FOOTER //
// ./src/devices/arris/System.js